@if (profile?.id) {
  <a
    class="bookmark-toggle position-relative d-flex align-items-center"
    data-testid="nav-bookmark-link"
    [routerLink]="['/bookmark-list']"
    title="Merkliste"
    i18n-title="@@bookmarkList.heading"
  >
    <fa-icon [icon]="faBookmark" class="fs-5"></fa-icon>
    @if (bookmarkCount) {
      <span class="badge rounded-pill bg-primary bookmark-count">{{ bookmarkCount }}</span>
    }
  </a>
}
